import React from 'react';
import Card from '../../components/ui/Card';
import { formatarMoeda } from '../../utils/formatters';

const HEADERS = ['Nº', 'Amortização', 'Juros', 'MIP', 'DFI', 'TGC', 'Parcela', 'Saldo Devedor'];

export default function TabelaParcelas({ parcelas }) {
  if (!parcelas?.length) return null;

  return (
    <Card style={{ overflowX: 'auto', marginTop: 20 }}>
      <h3 style={{ fontSize: '0.95rem', fontWeight: 700, marginBottom: 16 }}>📑 Evolução Detalhada</h3>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.8rem', minWidth: 650 }}>
        <thead>
          <tr style={{ background: 'var(--surface)', borderBottom: '2px solid var(--border-strong)' }}>
            {HEADERS.map((h) => (
              <th
                key={h}
                style={{
                  padding: '12px 10px',
                  textAlign: 'left',
                  fontWeight: 600,
                  color: 'var(--text-muted)',
                  whiteSpace: 'nowrap',
                }}
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {parcelas.map((p, idx) => (
            <tr
              key={idx}
              style={{
                borderBottom: '1px solid var(--border)',
                background: p.numero === 0 ? 'rgba(245,166,35,0.06)' : idx % 2 === 0 ? 'var(--white)' : 'var(--surface)',
              }}
            >
              <td style={{ padding: 10, color: 'var(--text-muted)', fontWeight: 600 }}>
                {p.numero === 0 ? '0 (inicial)' : p.numero}
              </td>
              <td style={{ padding: 10, color: 'var(--accent)' }}>{formatarMoeda(p.amortizacao)}</td>
              <td style={{ padding: 10, color: 'var(--rose)' }}>{formatarMoeda(p.juros)}</td>
              <td style={{ padding: 10, color: 'var(--gold)' }}>{formatarMoeda(p.mip)}</td>
              <td style={{ padding: 10, color: 'var(--gold)' }}>{formatarMoeda(p.dfi)}</td>
              <td style={{ padding: 10, color: 'var(--text-muted)' }}>{formatarMoeda(p.tgc)}</td>
              <td style={{ padding: 10, color: 'var(--blue)', fontWeight: 700 }}>{formatarMoeda(p.valorParcela)}</td>
              <td style={{ padding: 10 }}>{formatarMoeda(p.saldoDevedor)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Card>
  );
}